import isEmpty from 'lodash/isEmpty';
import { GlTooltipDirective, GlButton } from '@gitlab/ui';
import PreBlock from '../../duo_chat_message_tool_approval/components/pre_block';
import { checkClipboardPermissions } from '../utils';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

function makePretty(value) {
  let visited = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new WeakSet();
  if (isEmpty(value)) return '';
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      return value;
    }
  }
  try {
    if (typeof value === 'object' && visited.has(value)) {
      return '';
    }
    if ('content' in value) {
      visited.add(value);
      return makePretty(value.content, visited);
    }
    return JSON.stringify(value, null, 2);
  } catch (e) {
    return String(value);
  }
}
var script = {
  name: 'ToolKvSection',
  directives: {
    GlTooltip: GlTooltipDirective
  },
  components: {
    GlButton,
    PreBlock
  },
  inject: {
    renderGFM: {
      from: 'renderGFM',
      default: () => element => {
        element.classList.add('gl-markdown', 'gl-compact-markdown');
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean, Array, Object, null],
      required: false,
      default: null
    },
    // Optional monospace + scroll (useful for JSON / logs)
    maxHeight: {
      type: String,
      required: false,
      default: '260px'
    }
  },
  computed: {
    prettyText() {
      return makePretty(this.value);
    },
    hasContent() {
      return this.prettyText && this.prettyText.length > 0;
    }
  },
  methods: {
    async onCopyCodeSnippet() {
      const textToCopy = this.prettyText;
      const hasClipboardPermission = await checkClipboardPermissions();
      try {
        // Emit custom event for VS Code and other environments
        // This bubbles up to parent components that handle clipboard operations
        this.$emit('copy-code-snippet', {
          detail: {
            code: textToCopy
          }
        });

        // If we have clipboard permission, also copy directly
        if (hasClipboardPermission) {
          await navigator.clipboard.writeText(textToCopy);
        }
        this.$emit('copied', this.title);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Failed to copy:', e);
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasContent)?_c('figure',{staticClass:"gl-mb-0 gl-rounded-lg gl-bg-strong gl-p-2"},[_c('figcaption',{staticClass:"gl-display-flex gl-align-items-center gl-gap-2 gl-px-4 gl-py-3 gl-font-monospace gl-text-base gl-font-semibold gl-text-subtle",attrs:{"data-testid":"tool-section-header"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"gl-relative gl-block gl-overflow-auto gl-rounded-base gl-bg-default",style:({ maxHeight: _vm.maxHeight, overflow: 'auto' })},[_c('div',{staticClass:"gl-absolute gl-right-5 gl-top-5 gl-z-1"},[(_vm.prettyText)?_c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.viewport",value:({ boundary: 'viewport' }),expression:"{ boundary: 'viewport' }",modifiers:{"viewport":true}}],attrs:{"size":"small","icon":"copy-to-clipboard","title":"Copy to clipboard","aria-label":"Copy to clipboard"},on:{"click":function($event){$event.stopPropagation();return _vm.onCopyCodeSnippet.apply(null, arguments)}}}):_vm._e()],1),_vm._v(" "),_c('pre-block',{ref:"content",staticClass:"gl-font-mono gl-m-0 !gl-border-0 !gl-bg-default gl-text-strong",style:({ maxHeight: _vm.maxHeight })},[_vm._v(_vm._s(_vm.prettyText))])],1)]):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
